var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87344 3H19.1274C19.2852 2.99998 19.4408 3.0373 19.5814 3.1089C19.722 3.18051 19.8437 3.28437 19.9364 3.412L23.7594 8.668C23.8274 8.76152 23.8609 8.8757 23.8541 8.99112C23.8474 9.10653 23.8008 9.21603 23.7224 9.301L12.3674 21.602C12.3206 21.6526 12.2639 21.693 12.2007 21.7206C12.1376 21.7482 12.0694 21.7624 12.0004 21.7624C11.9315 21.7624 11.8633 21.7482 11.8002 21.7206C11.737 21.693 11.6803 21.6526 11.6334 21.602L0.278441 9.302C0.199792 9.21697 0.153106 9.10726 0.146358 8.99163C0.139609 8.876 0.173217 8.76161 0.241441 8.668L4.06444 3.412C4.15722 3.28437 4.27889 3.18051 4.41949 3.1089C4.5601 3.0373 4.71565 2.99998 4.87344 3Z",
    fill: "url(#paint0_linear_22_13)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_13",
    x1: -0.900497,
    y1: 1.69278,
    x2: 27.4498,
    y2: 15.5738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518437,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96918F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.0835220ef624aea66b43d1aeecf428f4.svg";
export { ForwardRef as ReactComponent };